// 物料地址
const url = "/business/yhMaterial/";
// 物料类型地址
const urls = "/business/yhMaterialType/";
// 供应商
const urlx = "/business/yhSupplier/";
// 机械
const urlc = "/business/yhMachinery/";
// 仓库
const urlh = "/business/yhWarehouse/";
// 入库
const urlr = "/business/yhStorage/";
// 出库
const urlo = "/business/yhCheckout/";
export default {
  // 物料类型汇总
  selectYhOutDetailedSum: "/business/yhDetailed/selectYhOutDetailedSum",
  // 分页查询出入库存明细列表
  selectYhDetailedByPage: "/business/yhDetailed/selectYhDetailedByPage",
  /** 物料管理 */
  insertYhMaterial: url + "insertYhMaterial",
  updateYhMaterial: url + "updateYhMaterial",
  deleteYhMaterial: url + "deleteYhMaterial",
  updateYhMaterialState: url + "updateYhMaterialState",
  selectYhMaterialByMaterialId: url + "selectYhMaterialByMaterialId",
  selectYhMaterialByPage: url + "selectYhMaterialByPage",
  importMaterial: url + "importMaterial",
  /** 物料类型 */
  insertYhMaterialType: urls + "insertYhMaterialType",
  updateYhMaterialType: urls + "updateYhMaterialType",
  deleteDataYhMaterialType: urls + "deleteDataYhMaterialType",
  selectYhMaterialTypeByList: urls + "selectYhMaterialTypeByList",
  selectYhMaterialTypeByPage: urls + "selectYhMaterialTypeByPage",
  updateYhMaterialTypeState: urls + "updateYhMaterialTypeState",

  /** 供应商管理 */
  insertYhSupplier: urlx + "insertYhSupplier",
  updateYhSupplier: urlx + "updateYhSupplier",
  deleteYhSupplier: urlx + "deleteYhSupplier",
  selectYhSupplierBySupplierId: urlx + "selectYhSupplierBySupplierId",
  selectYhSupplierByPage: urlx + "selectYhSupplierByPage",
  /** 机械管理 */
  insertYhMachinery: urlc + "insertYhMachinery",
  updateYhMachinery: urlc + "updateYhMachinery",
  deleteYhMachinery: urlc + "deleteYhMachinery",
  selectYhMachineryByMachineryId: urlc + "selectYhMachineryByMachineryId",
  selectYhMachineryByPage: urlc + "selectYhMachineryByPage",

  /** 仓库管理 */
  insertYhWarehouse: urlh + "insertYhWarehouse",
  updateYhWarehouse: urlh + "updateYhWarehouse",
  deleteYhWarehouse: urlh + "deleteYhWarehouse",
  selectYhWarehouseByList: urlh + "selectYhWarehouseByList",

  /** 入库管理 */
  insertYhStorage: urlr + "insertYhStorage",
  selectYhStorageById: urlr + "selectYhStorageById",
  selectYhStorageByPage: urlr + "selectYhStorageByPage",
  exportExcel: urlr + "exportExcel",

  /** 入库管理 */
  insertYhCheckout: urlo + "insertYhCheckout",
  selectYhCheckoutById: urlo + "selectYhCheckoutById",
  selectYhCheckoutByPage: urlo + "selectYhCheckoutByPage",
  exportExcel2: urlo + "exportExcel",

  /** 用料管理 */
  selectYhCheckoutStat: "/business/yhCheckout/selectYhCheckoutStat",

  /** 出入库明细导出 */
  exportExcel3: "/business/yhDetailed/exportExcel",
  /** 物料库存导出 */
  exportExcel4: "/business/yhMaterial/exportExcel",

  /** 物料基础信息 */
  stopYhMaterial: "/business/yhMaterial/stopYhMaterial",
  selectYhMaterialInfoByPage: "/business/yhMaterial/selectYhMaterialInfoByPage",
  importMaterialStore: "/business/yhMaterial/importMaterialStore",
  exportProjectDailyWord: '/business/yhProjectDaily/exportProjectDailyWord'
};
